import type { FeatureFlag } from '../graphql/types';

export const hasFeature = (featureFlags: FeatureFlag[], id: FeatureFlag): boolean => {
  return featureFlags.includes(id);
};
